/* WorkTriggerGeneralTabRenderer.js */

"use strict";
const _ = require("lodash");
const uiCore = require("@gluenetworks/steve_ui_core");
const InputTextControl = uiCore.Control.Textfield.InputText;
const CheckboxControl = uiCore.Control.Boolean.InputCheckbox;
//const ComboBoxControl = uiCore.Control.OptionSelection.Single.ComboBox;
const ScheduleComponent = require("@gluenetworks/schedule_component");
const RendererUtils = require("../../utils/RendererUtils");
//const InputControls = require('../../utils/InputControls');
const ButtonControl = uiCore.Control.Action.Button;
const NotificationsVeilComponent = require("@gluenetworks/notification_component");
const jsonPatch = require("fast-json-patch");

// const nodeTargetOptions = [
//     { label: 'From Event', value: 'EVENT' },
//     { label: 'All Nodes', value: 'ALL' },
//     { label: 'Selected Nodes', value: 'SPECIFIC' },
//     { label: 'Nodes of Type', value: 'NODE_TYPE' },
//     { label: 'Associated Nodes', value: 'ASSOCIATED_NODES' },
// ];
//
// const deviceTargetOptions = [
//     { label: 'From Event', value: 'EVENT' },
//     { label: 'All Devices', value: 'ALL' },
//     { label: 'Selected Devices', value: 'SPECIFIC' },
//     { label: 'Devices for Nodes of Type', value: 'NODE_TYPE' },
//     { label: 'Devices for Associated Nodes', value: 'ASSOCIATED_NODES' },
// ];
//
// const typeTargetInputsDef = [
//     {
//         type: 'constructTypes',
//         name: 'type',
//         label: 'Type',
//         construct: 'node'
//     }
// ];
//
// const associatedNodesTargetInputsDef = [
//     {
//         type: 'associatedNodes',
//         name: 'associated-nodes',
//         label: 'Associated Nodes',
//         class: 'inline-multi-control'
//     }
// ];

class WorkTriggerGeneralTabRenderer {
    constructor(model) {
        this._model = model;
        this._gameEditor = this._model.getGameEditor();
        this._rootElem = document.createElement("worktrig-general-tab-gl");
        this._rootElem.component = this._model;
        this._gridContainerElem = document.createElement("worktrig-general-grid-gl");
        this._gridContainerElem.classList.add("grid-container");
        this._rootElem.appendChild(this._gridContainerElem);

        this._formDisabled = this._model.disabled;
        let workTypeDef = this._model.getTriggerType().getWorkTypeDef();
        this._schedulerTypeControl = new ScheduleComponent(this._model.getSchedule(), {
            allowOne:
                workTypeDef && workTypeDef.allowOneSched
                    ? true
                    : workTypeDef.allowOne
                    ? true
                    : false,
            allowRepeat:
                workTypeDef && workTypeDef.allowRepeatSched
                    ? true
                    : workTypeDef.allowRepeat
                    ? true
                    : false,
            pollOnly: false,
            availOnly: false,
        });

        this._notificationOptionControl = undefined;

        this._openScheduleTargetsButton = new ButtonControl({label: "Edit"});

        this._openScheduleTargetsReadModeButton = new ButtonControl({label: "View"});

        this._openSchedulePlanTargetsReadModeButton = new ButtonControl({label: "View"});

        this._targetsCountControl = document.createElement("targets-count-label");
        this._readOnlyBtnShowed = false;
        this._workTypes = undefined;
        this._notifTypes = undefined;
        this._workInputControls = undefined;
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    _shutdown() {
        return Promise.resolve()
            .then(() => {
                let shutdowns = [
                    this._nameTextControl.shutdown(),
                    this._descriptionTextControl.shutdown(),
                    this._notificationOptionControl.shutdown(),
                    this._openScheduleTargetsButton.shutdown(),
                ];
                // if (this._targetControls) {
                //     shutdowns.push(this._targetControls.shutdown());
                // }
                // if (this._workInputControls) {
                //     shutdowns.push(this._workInputControls.shutdown());
                // }
                return Promise.all(shutdowns);
            })
            .then(() => {
                this._unregisterListeners();
                this._model = undefined;
                this._rootElem.remove();
                this._rootElem = undefined;
                this._gridContainerElem.remove();
                this._gridContainerElem = undefined;
                this._nameTextControl = undefined;
                this._targetsCount = undefined;
                this._descriptionTextControl = undefined;
                this._notificationOptionControl = undefined;
                //  this._triggerTypeTypeComboControl = undefined;
                //  this._workTypeComboControl = undefined;
                //  this._targetTypeComboControl = undefined;
                //  this._workTypes = undefined;
                //  this._notifTypes = undefined;
                //  this._targetControls = undefined;
                //  this._workInputControls = undefined;
                // this.beforeTargetTypeElem = undefined;
                this._openScheduleTargetsButton = undefined;
                this._readOnlyBtnShowed = undefined;
            })
            .catch((err) => {
                this.model._logger.warn(
                    {error: err},
                    "WorkTriggerGeneralTabRenderer._shutdown() error"
                );
                //console.error(err);
            });
    }

    _registerListeners() {
        this._model.on("Shutdown", (this._onShutdown = this._onShutdown.bind(this)));
        this._schedulerTypeControl.on(
            "UserValue",
            (this._onScheduleChange = this._onScheduleChange.bind(this))
        );
        this._nameTextControl.on("UserValue", (this._onNameChange = this._onNameChange.bind(this)));
        this._descriptionTextControl.on(
            "UserValue",
            (this._onDescriptionChange = this._onDescriptionChange.bind(this))
        );
        this._captureSnapshotControl.on(
            "UserValue",
            (this._onCaptureSnapshotChange = this._onCaptureSnapshotChange.bind(this))
        );
        this._snapshotNameControl.on(
            "UserValue",
            (this._onSnapshotNameChange = this._onSnapshotNameChange.bind(this))
        );
        this._notificationOptionControl.on(
            "EmailListWasChanged",
            (this._setNotificationOption = this._setNotificationOption.bind(this))
        );
        this._notificationOptionControl.on(
            "ValidationStateChanged",
            (this._onNotificationsValidationChanged =
                this._onNotificationsValidationChanged.bind(this))
        );
        // this._triggerTypeTypeComboControl.on('UserValue', this._onTriggerTypeTypeChange = this._onTriggerTypeTypeChange.bind(this));
        // this._workTypeComboControl.on('UserValue', this._onWorkTypeChange = this._onWorkTypeChange.bind(this));
        // this._targetTypeComboControl.on('UserValue', this._onTargetTypeChange = this._onTargetTypeChange.bind(this));

        this._openScheduleTargetsButton.on(
            "UserClick",
            (this._onOpenScheduleTargetsButtonClick =
                this._onOpenScheduleTargetsButtonClick.bind(this))
        );

        this._openScheduleTargetsReadModeButton.on(
            "UserClick",
            (this._onOpenScheduleTargetsReadModeButtonClick =
                this._onOpenScheduleTargetsReadModeButtonClick.bind(this))
        );

        this._openSchedulePlanTargetsReadModeButton.on(
            "UserClick",
            (this._onOpenSchedulePlanTargetsReadModeButtonClick =
                this._onOpenSchedulePlanTargetsReadModeButtonClick.bind(this))
        );

        this._model.on(
            "TriggerTypePropertiesChanged",
            (this._onTriggerTypePropertiesChanged = this._onTriggerTypePropertiesChanged.bind(this))
        );
        this._model.on(
            "WorkTargetChanged",
            (this._onWorkTargetChanged = this._onWorkTargetChanged.bind(this))
        );
    }

    _unregisterListeners() {
        this._model.removeListener("Shutdown", this._onShutdown);
        this._model.removeListener("WorkTargetChanged", this._onWorkTargetChanged);
        this._schedulerTypeControl.removeListener("UserValue", this._onScheduleChange);
        this._nameTextControl.removeListener("UserValue", this._onNameChange);
        this._descriptionTextControl.removeListener("UserValue", this._onDescriptionChange);
        this._notificationOptionControl.removeListener("UserValue", this._setNotificationOption);
        this._notificationOptionControl.removeListener(
            "ValidationStateChanged",
            this._onNotificationsValidationChanged
        );
        this._openScheduleTargetsButton.removeListener(
            "UserClick",
            this._onOpenScheduleTargetsButtonClick
        );
        this._openScheduleTargetsReadModeButton.removeListener(
            "ÜserClick",
            this._onOpenScheduleTargetsReadModeButtonClick
        );
        this._openSchedulePlanTargetsReadModeButton.removeListener(
            "UserClick",
            this._onOpenSchedulePlanTargetsReadModeButtonClick
        );
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        if (this._gridContainerElem.hasChildNodes()) {
            return Promise.resolve();
        }

        this._nameTextControl = new InputTextControl({disabled: this._formDisabled});
        this._descriptionTextControl = new InputTextControl({disabled: this._formDisabled});
        this._captureSnapshotControl = new CheckboxControl({
            darkTheme: false,
            labelShown: true,
            label: "Capture new snapshot",
            title: "Capture new snapshot",
            disabled: this._formDisabled,
        });
        this._snapshotNameControl = new InputTextControl({disabled: true});
        this._notificationOptionControl = new NotificationsVeilComponent(
            this.model._logger,
            this.model.gameEditor.getUserSession(),
            {
                darkTheme: false,
                workType: this.model.workType,
                subWorkType: this.model.subWorkType,
                disabled: this._formDisabled,
                useNativeValidation: false,
            },
            this.model.fixWorkInput(this.model.triggerType.workInput),
            this._model._ControlUser,
            this._model.triggerType.createdBy
        );
        // this._targetTypeComboControl = new ComboBoxControl({ options: [], showFilter: false ,disabled:this._formDisabled});

        // this._workTypes = this._model.getWorkTypes();
        // let workTypeComboOptions = [];
        // _.forEach(this._workTypes, (workType, id) => {
        //     workTypeComboOptions.push({ label: workType.displayName || workType.name, value: id });
        // });
        // this._workTypeComboControl = new ComboBoxControl({ options: workTypeComboOptions, showFilter: false });

        // If isExhausted comes true disable the form, and render just date
        if (!this._formDisabled) {
            this._schedulerTypeControl.theme = "light";
        }

        //let targetMethod = this._model.getWorkTarget().method,
        //    targetsVisible = false,
        //    targetsEditEnable = true;
        /*
        
        let targetsVisible = ["multi", "single"].includes(targetMethod);
        let allTarget = false;

        if (targetsVisible) {
            this._targetsCountControl.innerHTML = this._model.getWorkTargetCount();
        } else {
            allTarget =
                targetMethod === "query" && _.isEmpty(this._model.getWorkTarget().query);
            this._targetsCountControl.innerHTML = allTarget ? " All" : "Dynamic";
        }
        */

        const isFutureSchedule = !!this._model._triggerType.getNextExecutionTime();

        let targetsMode = "NotSpecified",
            dynamicFilterNotice;

        return Promise.resolve()
            .then(() => {
                let targetMethod = this._model.getWorkTarget().method,
                    //isItOsPlanSolution = this.model.solution !== "Os Manager" && this.model.triggerType.subWorkType !== "Os Plan",
                    renderPromises = [
                        this._nameTextControl.renderer.render(),
                        this._descriptionTextControl.renderer.render(),
                        //this._workTypeComboControl.renderer.render,
                        this._schedulerTypeControl.renderer.render(),
                        //this._triggerTypeTypeComboControl.renderer.render,
                        //this._targetTypeComboControl.renderer.render()
                    ];

                // TODO: Temporary fix for case 28609 to be replaced by long-term fix -- see case 28614
                // START --
                // if (this._model.getTargetEntityType() !== "Device") {
                //     this._openScheduleTargetsButton.hide();
                //     this._openScheduleTargetsReadModeButton.hide();
                // }
                // END --

                const workTarget = this.model._triggerType.getWorkTarget();
                if (workTarget.entityType === "OsUpgradePlan") {
                    this._targetsCountControl.innerText = this.model.getWorkTargetCount(true);
                    targetsMode = "PlanReadOnlyMode";
                    renderPromises.push(
                        this._openSchedulePlanTargetsReadModeButton.renderer.render()
                    );
                } else {
                    switch (targetMethod) {
                        case "query":
                            if (_.isEmpty(this._model.getWorkTarget().query)) {
                                this._targetsCountControl.innerText = " All";
                                if (isFutureSchedule) {
                                    targetsMode = "EditMode";
                                    renderPromises.push(
                                        this._openScheduleTargetsButton.renderer.render()
                                    );
                                }
                            } else {
                                this._targetsCountControl.innerText = "(Calculating...)";
                                dynamicFilterNotice = document.createElement("notice");
                                dynamicFilterNotice.innerText = "Dynamic Filter in use";

                                if (!isFutureSchedule) {
                                    targetsMode = "ReadOnlyMode";
                                    renderPromises.push(
                                        this._openScheduleTargetsReadModeButton.renderer.render()
                                    );
                                } else {
                                    targetsMode = "EditMode";
                                    renderPromises.push(
                                        this._openScheduleTargetsButton.renderer.render()
                                    );
                                }
                            }
                            break;
                        case "multi":
                        case "single":
                            this._targetsCountControl.innerText =
                                this.model.getWorkTargetCount(true);

                            if (this._formDisabled) {
                                targetsMode = "ReadOnlyMode";
                                renderPromises.push(
                                    this._openScheduleTargetsReadModeButton.renderer.render()
                                );
                            } else {
                                targetsMode = "EditMode";
                                renderPromises.push(
                                    this._openScheduleTargetsButton.renderer.render()
                                );
                            }

                            break;
                        case "related":
                            targetsMode = "ReadOnlyMode";
                            renderPromises.push(this._openScheduleTargetsButton.renderer.render());
                            this._targetsCountControl.innerText =
                                this.model.getWorkTargetCount(true);
                            break;
                        default:
                            this._targetsCountControl.innerText =
                                this.model.getWorkTargetCount(true);
                    }
                }
                if (this.model._triggerType.workType === "audit") {
                    renderPromises.push(this._captureSnapshotControl.renderer.render());
                    renderPromises.push(this._snapshotNameControl.renderer.render());
                }

                return Promise.all(renderPromises);
            })
            .then(() => {
                let targetTypeParts;
                RendererUtils.groupGridRowElements(
                    1,
                    this._gridContainerElem,
                    "name",
                    "Name",
                    this._nameTextControl
                );
                RendererUtils.groupGridRowElements(
                    2,
                    this._gridContainerElem,
                    "description",
                    "Description",
                    this._descriptionTextControl
                );
                /*RendererUtils.groupGridRowElements(3, this._gridContainerElem, 'trig-type', 'Trigger', this._triggerTypeTypeComboControl);*/
                /*RendererUtils.groupGridRowElements(5, this._gridContainerElem, 'work-type', 'Work Type', this._workTypeComboControl);*/
                RendererUtils.groupGridRowElements(
                    4,
                    this._gridContainerElem,
                    "scheduler",
                    "Schedule",
                    this._schedulerTypeControl
                );
                //let targetTypeParts = RendererUtils.groupGridRowElements(6, this._gridContainerElem, 'target-type', 'Target(s)', this._targetTypeComboControl);
                const workTarget = this.model._triggerType.getWorkTarget();
                if (
                    workTarget.entityType === "OsUpgradePlan" ||
                    workTarget.entityType === "Device" ||
                    (workTarget.construct && workTarget.construct === "node")
                ) {
                    switch (targetsMode) {
                        case "ReadOnlyMode":
                            targetTypeParts = RendererUtils.groupGridRowElements(
                                6,
                                this._gridContainerElem,
                                "target-type",
                                "Targets",
                                [
                                    this._targetsCountControl,
                                    this._openScheduleTargetsReadModeButton,
                                    dynamicFilterNotice,
                                ]
                            );
                            this.beforeTargetTypeElem = targetTypeParts[0];
                            break;
                        case "EditMode":
                            targetTypeParts = RendererUtils.groupGridRowElements(
                                6,
                                this._gridContainerElem,
                                "target-type",
                                "Targets",
                                [
                                    this._targetsCountControl,
                                    this._openScheduleTargetsButton,
                                    dynamicFilterNotice,
                                ]
                            );
                            this.beforeTargetTypeElem = targetTypeParts[0];
                            break;
                        case "PlanReadOnlyMode":
                            targetTypeParts = RendererUtils.groupGridRowElements(
                                6,
                                this._gridContainerElem,
                                "target-type",
                                "Targets",
                                [
                                    this._targetsCountControl,
                                    this._openSchedulePlanTargetsReadModeButton,
                                    dynamicFilterNotice,
                                ]
                            );
                            this.beforeTargetTypeElem = targetTypeParts[0];
                            break;
                        default:
                            RendererUtils.groupGridRowElements(
                                6,
                                this._gridContainerElem,
                                "target-type",
                                "Targets",
                                this._targetsCountControl
                            );
                    }
                }
                if (this.model._triggerType.workType === "audit") {
                    RendererUtils.groupGridRowElements(
                        5,
                        this._gridContainerElem,
                        "snapshot-selection",
                        "Action",
                        [this._captureSnapshotControl, this._snapshotNameControl]
                    );
                }
                RendererUtils.groupGridRowElements(
                    5,
                    this._gridContainerElem,
                    "Notification",
                    "Notification",
                    this._notificationOptionControl
                );
                // RendererUtils.groupGridRowElements(10, this._gridContainerElem, 'schedule-targets', '', this._openScheduleTargetsButton);

                this._registerListeners();
                this._setTriggerType(this._model.getTriggerType());

                this._model.hideViewActions();
            })
            .catch((err) => {
                this.model._logger.warn(
                    {error: err},
                    "WorkTriggerGeneralTabRenderer.render() error"
                );
            });
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onNameChange(newName, oldName) {
        newName = newName.trim();
        if (newName !== oldName) {
            // this._model.setTriggerTypeProperty("name", newName);
            this._model.setTriggerTypeProperty("displayName", newName);
        }
    }

    _onDescriptionChange(newDescription, oldDescription) {
        if (!newDescription && !oldDescription) {
            return;
        }
        if (typeof newDescription === "string") {
            newDescription = newDescription.trim();
        }
        if (newDescription !== oldDescription) {
            this._model.setTriggerTypeProperty("description", newDescription);
        }
    }

    _onCaptureSnapshotChange(newVal, oldVal) {
        /* eslint-disable eqeqeq */
        if (newVal != oldVal) {
            this._model.setTriggerTypeProperty("workInput.captureNewSnapShots", newVal);
        }
        this._snapshotNameControl.setDisabled(!newVal);
        /* eslint-enable eqeqeq */
    }

    _onSnapshotNameChange(newVal, oldVal) {
        /* eslint-disable eqeqeq */
        if (newVal != oldVal) {
            this._model.setTriggerTypeProperty("workInput.snapshotName", newVal);
        }
        /* eslint-enable eqeqeq */
    }

    _onTriggerTypePropertiesChanged(inputData, oldData) {
        let currentTriggerType = _.cloneDeep(oldData);
        jsonPatch.applyPatch(currentTriggerType, this._model._triggerType.pendingPatches || []);
        const currentNameValue = this._nameTextControl.value;
        const currentDescriptionValue = this._descriptionTextControl.value;
        const currentSanpshotVal = this._captureSnapshotControl.value;
        const currentSnapshotName = this._snapshotNameControl.value;
        // const { notifyMe, notifyEmail, notifyActionGroupDefault } = this._notificationOptionControl;

        const isDirtyProperty = (propertyName) => {
            let result = false;
            let pendingPatches = this._model._triggerType.pendingPatches || [];
            if (!pendingPatches || !_.isArray(pendingPatches) || !propertyName) {
                return result;
            }
            pendingPatches.every((value) => {
                if (
                    value &&
                    value.path &&
                    value.path.substr(1, propertyName.length) === propertyName
                ) {
                    result = true;
                    return false;
                }
                return true;
            });
            return result;
        };

        const updateForm = (fullReset = false) => {
            // Update name
            if (fullReset || !isDirtyProperty("displayName")) {
                this._nameTextControl.setValue(inputData.displayName, false);
                this._onNameChange(inputData.displayName, currentNameValue);
            }

            // Update description
            if (fullReset || !isDirtyProperty("description")) {
                this._descriptionTextControl.setValue(inputData.description, false);
                this._onDescriptionChange(inputData.description, currentDescriptionValue);
            }

            //update snapshot checkbox
            if (fullReset || !isDirtyProperty("workInput/captureNewSnapShots")) {
                this._captureSnapshotControl.setValue(
                    inputData.workInput.captureNewSnapShots,
                    false
                );
                this._onCaptureSnapshotChange(
                    inputData.workInput.captureNewSnapShots,
                    currentSanpshotVal
                );
            }

            if (fullReset || !isDirtyProperty("workInput/snapshotName")) {
                this._snapshotNameControl.setValue(inputData.workInput.snapshotName, "");
                this._onSnapshotNameChange(inputData.workInput.snapshotName, currentSnapshotName);
            }

            // Update schedule
            if (fullReset || !isDirtyProperty("schedule")) {
                this._schedulerTypeControl._renderer
                    ._renderCurrentSchedule(inputData.schedule)
                    .then(() => {
                        // Scheduler re-rendered, populate it with new values
                        this._schedulerTypeControl.setSchedule(inputData.schedule, false);
                        this._onScheduleChange(inputData.schedule);
                    });
            }

            // Update work targets
            if (fullReset || !isDirtyProperty("workTarget")) {
                this._model.setWorkTarget(inputData.workTarget);
                this._targetsCountControl.innerHTML = this._model.getWorkTargetCount(true);
            }

            // Update notification options
            if (
                fullReset ||
                !isDirtyProperty("workInput/notifyEmail") ||
                fullReset ||
                !isDirtyProperty("workInput/notifyMe") ||
                fullReset ||
                !isDirtyProperty("workInput/notifyActionGroupDefault")
            ) {
                this._setNotificationOption({
                    notifyMe: inputData.workInput.notifyMe,
                    notifyEmail: inputData.workInput.notifyEmail,
                    notifyActionGroupDefault: inputData.workInput.notifyActionGroupDefault,
                });
                // TODO _notificationOptionControl cannot be re-rendered after updating its data model so interim solution was to re-create control
                // TODO Long-term solution is to improve render() of @gluenetworks/notification_component so it takes into account updated data
                document.querySelector("notification-container").innerHTML = "";
                this._notificationOptionControl.removeListener(
                    "UserValue",
                    this._setNotificationOption
                );
                this._notificationOptionControl.removeListener(
                    "ValidationStateChanged",
                    this._onNotificationsValidationChanged
                );
                this._notificationOptionControl.shutdown();
                this._notificationOptionControl = new NotificationsVeilComponent(
                    this.model._logger,
                    this.model.gameEditor.getUserSession(),
                    {
                        darkTheme: false,
                        workType: this.model.workType,
                        subWorkType: this.model.subWorkType,
                        disabled: this._formDisabled,
                        useNativeValidation: false,
                    },
                    this.model.fixWorkInput(this.model.triggerType.workInput),
                    this._model._ControlUser,
                    this._model.triggerType.createdBy
                );
                this._notificationOptionControl.on(
                    "EmailListWasChanged",
                    (this._setNotificationOption = this._setNotificationOption.bind(this))
                );
                this._notificationOptionControl.on(
                    "ValidationStateChanged",
                    (this._onNotificationsValidationChanged =
                        this._onNotificationsValidationChanged.bind(this))
                );
                document
                    .querySelector("notification-container")
                    .appendChild(this._notificationOptionControl._renderer._rootElem);
            }
            return Promise.resolve();
        };

        if (
            inputData.lastOccurrenceStatus === "STARTING" ||
            inputData.lastOccurrenceStatus === "RUNNING"
        ) {
            this._gridContainerElem.classList.add("disabled-form");
            this._model.hideViewActions();
            return Promise.resolve();
        } else if (_.get(inputData, "isExhausted", false)) {
            this._gridContainerElem.classList.add("disabled-form");
            updateForm(true);
            this._triggerType.clearPendingPatches();
            return Promise.resolve();
        } else {
            this._gridContainerElem.classList.remove("disabled-form");
            if (this._model._triggerType.isDirty()) {
                this._model.showViewActions();
            }
            if (_.get(inputData, "schedule.type", "one") === "one" && !this._readOnlyBtnShowed) {
                this._openScheduleTargetsButton.hide();
                if (document.querySelector("target-type-container")) {
                    document
                        .querySelector("target-type-container")
                        .appendChild(this._openScheduleTargetsReadModeButton._renderer._rootElem);
                }
                this._readOnlyBtnShowed = true;
            }
        }

        // Check if we get event on the other of changed page (other screen)
        /* eslint-disable eqeqeq */
        if (
            inputData &&
            oldData &&
            ((inputData.displayName != oldData.displayName && isDirtyProperty("displayName")) ||
                (inputData.description != oldData.description && isDirtyProperty("description")) ||
                (!_.isEqual(inputData.schedule, oldData.schedule) &&
                    isDirtyProperty("displayName")) ||
                (!_.isEqual(inputData.workTarget, oldData.workTarget) &&
                    isDirtyProperty("workTarget")) ||
                (!_.isEqual(inputData.workInput.notifyEmail, oldData.workInput.notifyEmail) &&
                    isDirtyProperty("workInput/notifyEmail")) ||
                (inputData.workInput.notifyMe != oldData.workInput.notifyMe &&
                    isDirtyProperty("workInput/notifyMe")) ||
                (inputData.workInput.notifyActionGroupDefault !=
                    oldData.workInput.notifyActionGroupDefault &&
                    isDirtyProperty("workInput/notifyActionGroupDefault")) ||
                (inputData.workInput.captureNewSnapShots != oldData.workInput.captureNewSnapShots &&
                    isDirtyProperty("workInput/captureNewSnapshots")))
        ) {
            /* eslint-enable eqeqeq */
            return this._model.gameEditor
                .runQuickConfirmationActionWorkflow(
                    {
                        message:
                            "This schedule has been updated by another user. Do you want to refresh its details? All changes will be lost.",
                        title: "Update Confirmation Check",
                        confirmDetails: {
                            text: "Yes",
                            type: "text",
                        },
                    },
                    () => updateForm(true),
                    () => {
                        Promise.resolve();
                    }
                )
                .catch((err) => {
                    this.model._logger.warn(
                        {error: err},
                        "WorkTriggerGeneralTabRenderer.render() error"
                    );
                });
        } else {
            updateForm(false);
            return Promise.resolve();
        }
    }

    _onWorkTargetChanged() {
        this._targetsCountControl.innerHTML = this._model.getWorkTargetCount(true);
    }

    _setNotificationOption(option) {
        this._model.setNotifyMe(option);
    }

    _onNotificationsValidationChanged(isValid) {
        this.model.notificationsValidationChanged(isValid);
    }

    // _onTriggerTypeChange(newTriggerType, oldTriggerType) {
    //     if (!_.isEqual(newTriggerType, oldTriggerType)) {
    //         this._setTriggerType(newTriggerType);
    //         this._model._showViewActions();
    //     }
    // }

    // _onTriggerTypeTypeChange(newTriggerTypeTypeId, oldTriggerTypeTypeId) {
    //     if (newTriggerTypeTypeId !== oldTriggerTypeTypeId) {
    //         let isSchedule = this._triggerTypeTypeComboControl.value === 'SCHEDULE';
    //         let workType = this._workTypes[this._workTypeComboControl.value];
    //         let targetType = _.get(workType, 'targetConstruct') ? 'construct' : 'entity';
    //         this._populateTargetTypes(isSchedule, targetType, true);
    //         this._setTriggerTypeType(newTriggerTypeTypeId, true);
    //     }
    // }
    //
    // _onWorkTypeChange(newWorkTypeId, oldWorkTypeId) {
    //     if (newWorkTypeId !== oldWorkTypeId) {
    //         let isSchedule = this._triggerTypeTypeComboControl.value === 'SCHEDULE';
    //         this._setWorkType(newWorkTypeId, isSchedule, true);
    //         this._showWorkInputControls();
    //     }
    // }
    //
    // _onTargetTypeChange(newTargetType, oldTargetType) {
    //     if (newTargetType !== oldTargetType) {
    //         this._model.setWorkTargetType(newTargetType);
    //         this._setTargetFromTargetType(newTargetType, true);
    //     }
    // }
    //
    // _onTargetControlsValueChange(controlValues) {
    //     this._setTargetControls(controlValues);
    // }
    //
    // _onWorkInputControlsValueChange(controlValues) {
    //     this._model.setWorkInput(controlValues);
    // }

    _onOpenScheduleTargetsButtonClick() {
        this._model.setEditorMode("targets");
    }

    _onOpenScheduleTargetsReadModeButtonClick() {
        this._model.setEditorMode("targetsReadMode");
    }

    _onOpenSchedulePlanTargetsReadModeButtonClick() {
        this._model.setEditorMode("planTargetsReadMode");
    }

    _onShutdown() {
        this._shutdown();
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /*******************************************/

    _showEventDate(schedDateTime) {
        if (schedDateTime) {
            let now = new Date();
            const date = new Date(
                schedDateTime.hasOwnProperty("year") ? schedDateTime.year : now.getFullYear(),
                schedDateTime.hasOwnProperty("month") ? schedDateTime.month : now.getMonth(),
                schedDateTime.hasOwnProperty("date") ? schedDateTime.date : now.getDate(),
                schedDateTime.hasOwnProperty("hour") ? schedDateTime.hour : 0,
                schedDateTime.hasOwnProperty("minute") ? schedDateTime.minute : 0
            );
            return date.toLocaleDateString() + " " + date.toLocaleTimeString();
        }
    }

    _onScheduleChange(s) {
        if (_.get(s, "every.hour") && _.get(this._model, ["triggerType", "name"]) === "everymin") {
            _.set(s, "every.minute", s.every.hour);
            delete s.every.hour;
        }
        this._model.setSchedule(s);
    }

    _setTriggerType(triggerType) {
        this._nameTextControl.setValue(triggerType.displayName);
        this._descriptionTextControl.setValue(triggerType.description);
        this._schedulerTypeControl.setSchedule(triggerType.schedule);
        this._captureSnapshotControl.setValue(triggerType.workInput.captureNewSnapShots);
        this._snapshotNameControl.setDisabled(!triggerType.workInput.captureNewSnapShots);
        this._snapshotNameControl.setValue(triggerType.workInput.snapshotName);
        // let isSchedule = _.get(triggerType, 'triggerType') === 'SCHEDULE';
        // let workTypeId = _.get(this._model.getWorkType(), 'id');
        // this._setWorkType(workTypeId, isSchedule, false);
        // this._setTargetTypeFromTarget(triggerType.workTarget)
        //     .then(() => {
        //         if (triggerType.triggerType === 'SCHEDULE') {
        //             this._setTriggerTypeType('SCHEDULE');
        //         } else {
        //             let notifType = this._findNotifType(triggerType);
        //             this._setTriggerTypeType(_.get(notifType, 'id'));
        //         }
        //         this._showWorkInputControls();
        //     });
    }

    // _setWorkType(workTypeId, isSchedule, setByUser) {
    //     let workType = this._workTypes[workTypeId] || _.get(this._workTypeComboControl.options[0], 'value');
    //     let targetType = _.get(workType, 'targetConstruct') ? 'construct' : 'entity';
    //     if (workType) {
    //         if (setByUser) {
    //             this._model.setWorkType(workType);
    //         }
    //         this._workTypeComboControl.setValue(workType.id, setByUser);
    //         this._populateTargetTypes(isSchedule, targetType, setByUser);
    //         if (this._workInputControls) {
    //             this._workInputControls.removeListener('ValueChange', this._onWorkInputControlsValueChange);
    //             this._workInputControls.shutdown();
    //             this._workInputControls = undefined;
    //         }
    //     }
    // }
    //
    // _showWorkInputControls() {
    //     let workType = this._workTypes[this._workTypeComboControl.value];
    //     if (workType.workInputs && workType.workInputs.length < 2) {
    //         this._workInputControls = new InputControls(this._gameEditor, workType.workInputs, this._gridContainerElem, 4);
    //         return this._workInputControls.render(this.beforeTargetTypeElem)
    //             .then(() => {
    //                 let workInputVals = this._model.getWorkInput();
    //                 if (_.isEmpty(workInputVals)) {
    //                     this._model.setWorkInput(this._workInputControls.getValues());
    //                 } else {
    //                     this._workInputControls.setValues(this._model.getWorkInput());
    //                 }
    //                 this._workInputControls.on('ValueChange', this._onWorkInputControlsValueChange.bind(this));
    //             });
    //     }
    //     return Promise.resolve();
    // }
    //
    // _setTriggerTypeType(triggerTypeId, setByUser) {
    //     let notifType = this._notifTypes[triggerTypeId];
    //     if (setByUser) {
    //         if (notifType) {
    //             this._model.setNotifTypeDef(notifType.notifDef);
    //         } else {
    //             this._model.setSchedule();
    //         }
    //     } else {
    //         this._triggerTypeTypeComboControl.setValue(triggerTypeId, setByUser);
    //     }
    // }
    //
    // _populateTargetTypes(isSchedule, targetType, setByUser) {
    //     let options = targetType === 'construct' ? nodeTargetOptions : deviceTargetOptions;
    //     if (isSchedule) {
    //         options = _.drop(options);
    //     }
    //     if (!_.isEqual(this._targetTypeComboControl.options, options)) {
    //         this._targetTypeComboControl.setOptions(options);
    //         this._targetTypeComboControl.setValue(options[0].value);
    //         if (setByUser) {
    //             this._setTargetFromTargetType(options[0].value, true);
    //         }
    //     }
    // }
    //
    // _setTargetTypeFromTarget(workTarget, setByUser) {
    //     let workTargetType = this._model.mapWorkTargetToTargetType(workTarget);
    //     if (setByUser) {
    //         this._model.setWorkTargetType(workTargetType);
    //     } else {
    //         this._targetTypeComboControl.setValue(workTargetType || this._targetTypeComboControl.options[0].value, setByUser);
    //     }
    //     return this._showTargetInputs(workTargetType);
    // }
    //
    // _setTargetFromTargetType(targetType) {
    //     let workTarget = this._model.mapWorkTargetTypeToTarget(targetType);
    //     this._model.setWorkTarget(workTarget);
    //     return this._showTargetInputs(targetType);
    // }

    // _showTargetInputs(workTargetType) {
    //     if (this._targetControls) {
    //         this._targetControls.shutdown();
    //         this._targetControls = undefined;
    //     }
    //     switch (workTargetType) {
    //         case 'NODE_TYPE':
    //             this._targetControls = new InputControls(this._gameEditor, typeTargetInputsDef, this._gridContainerElem, 7);
    //             break;
    //         case 'ASSOCIATED_NODES':
    //             this._targetControls = new InputControls(this._gameEditor, associatedNodesTargetInputsDef, this._gridContainerElem, 7);
    //             break;
    //         default:
    //             return Promise.resolve();
    //     }
    //     if (this._targetControls) {
    //         this._targetControls.on('ValueChange', this._onTargetControlsValueChange = this._onTargetControlsValueChange.bind(this));
    //         return this._targetControls.render()
    //             .then(() => {
    //                 this._setTargetControls(this._targetControls.getValues());
    //             });
    //     }
    // }

    // _setTargetControls(controlValues) {
    //     if (controlValues) {
    //         let workTarget = { category: 'construct' };
    //         if (Object.keys(controlValues)[0] === 'associated-nodes[0]') {
    //             workTarget.method = 'associatedNodes';
    //             workTarget.baseConstruct = controlValues['associated-nodes[0]'];
    //             workTarget.baseInstanceTypeName = controlValues['associated-nodes[1]'];
    //             workTarget.baseInstanceId = controlValues['associated-nodes[2]'];
    //         } else if (controlValues.type) {
    //             workTarget.method = 'query';
    //             workTarget.construct = 'node';
    //             workTarget.query = { typeName: controlValues.type };
    //         }
    //         this._model.setWorkTarget(workTarget);
    //     }
    // }

    // _findNotifType(triggerType) {
    //     let triggerNotifType = triggerType.entityNotification || triggerType.constructPropertyNotification;
    //     return _.values(this._notifTypes).find(notifType => {
    //         return _.isEqual(notifType.notifDef, triggerNotifType);
    //     });
    // }
}

module.exports = WorkTriggerGeneralTabRenderer;
